import PageShell from "@/components/PageShell";

const Section = ({ title, children }) => (
  <div className="mb-8">
    {title && <h2 className="font-display text-xl md:text-2xl font-bold text-brand-ink mb-3">{title}</h2>}
    <div className="text-brand-slate/75 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function CookiePolicy() {
  return (
    <PageShell testid="cookie-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 md:py-24">
        <span className="text-brand-terracotta font-semibold tracking-[0.2em] uppercase text-sm">Documento legale</span>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-brand-ink mt-4 mb-3">Cookie Policy</h1>
        <p className="text-brand-slate/50 mb-12">Ultimo aggiornamento: 21 febbraio 2026</p>

        <Section>
          <p>La presente Cookie Policy descrive l'utilizzo dei cookie da parte di questo sito web, in conformità al Regolamento (UE) 2016/679 (GDPR) e alla Direttiva ePrivacy.</p>
        </Section>

        <Section title="1. Titolare del trattamento">
          <p className="font-semibold text-brand-ink">Multiservice la Fenice S.R.L.s</p>
          <p>Via A. Carrelli, 50 - 80126 Napoli (NA), Italia<br />
          P. IVA e C.F.: 11151291215 · REA: NA-1158476<br />
          Email: multiservicelafenice@pec.it</p>
        </Section>

        <Section title="2. Cosa sono i cookie">
          <p>I cookie sono piccoli file di testo che i siti web visitati inviano al dispositivo dell'utente (computer, smartphone o tablet), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. I cookie consentono al sito di riconoscere il dispositivo dell'utente e migliorare l'esperienza di navigazione.</p>
        </Section>

        <Section title="3. Tipologie di cookie utilizzati">
          <p><strong>Cookie tecnici essenziali</strong> — necessari per il corretto funzionamento del sito e non disattivabili. Permettono la navigazione, la sicurezza del sito e la gestione delle sessioni. Base giuridica: legittimo interesse del titolare.</p>
          <p><strong>Cookie di funzionalità</strong> — consentono al sito di ricordare le scelte effettuate dall'utente e migliorare l'esperienza di navigazione. Possono essere installati solo con il consenso dell'utente.</p>
          <p><strong>Cookie di terze parti</strong> — servizi tecnici e funzionali eventualmente necessari al funzionamento del sito.</p>
        </Section>

        <Section title="4. Gestione del consenso">
          <p>Al primo accesso al sito, l'utente può accettare tutti i cookie, rifiutare i cookie non essenziali oppure gestire le preferenze. Il consenso può essere modificato in qualsiasi momento.</p>
        </Section>

        <Section title="5. Come disabilitare i cookie dal browser">
          <p>L'utente può gestire o disabilitare i cookie tramite le impostazioni del proprio browser (Google Chrome, Mozilla Firefox, Microsoft Edge, Safari). La disabilitazione dei cookie tecnici potrebbe compromettere il funzionamento del sito.</p>
        </Section>

        <Section title="6. Conservazione dei dati">
          <p>I cookie vengono conservati per il tempo necessario alle finalità per cui sono stati installati, in conformità con la normativa vigente.</p>
        </Section>

        <Section title="7. Diritti dell'utente">
          <p>L'utente ha il diritto di accedere ai propri dati, richiederne la cancellazione, limitare od opporsi al trattamento. Per esercitare tali diritti è possibile contattare: <a href="mailto:multiservicelafenice@pec.it" className="text-brand-goldDark font-semibold">multiservicelafenice@pec.it</a></p>
        </Section>

        <Section title="8. Modifiche alla Cookie Policy">
          <p>Il Titolare si riserva il diritto di modificare la presente Cookie Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.</p>
        </Section>
      </div>
    </PageShell>
  );
}
